import React, { Dispatch, useEffect } from 'react';
import { Props } from './props';
import { Form, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../store/ducks/cidadeOrigem/actions';
import { ApplicationState } from '../../../../../store';
import { TextLabel } from 'components/TextLabel';

const CidadeOrigem: React.FC<Props> = ({ setCodCidadeOrigem, setNomeCidadeOrigem }) => {
  const { Option } = Select;
  const dispatch = useDispatch<Dispatch<Action>>();
  const cidades = useSelector((state: ApplicationState) => state.CidadeOrigem.data);

  useEffect(() => {
    dispatch(loadRequest());
  }, [dispatch]);

  const handleChang = (value: any, e: any) => {
    setCodCidadeOrigem(value);
    setNomeCidadeOrigem?.(e.children);
  };

  return (
    <Form.Item
      name="nomeCidadeOrigem"
      label={<TextLabel>Cidade Origem</TextLabel>}
      rules={[{ required: true, message: 'Por favor preencha este campo!' }]}
    >
      <Select onChange={handleChang}>
        {cidades?.map((cidade: any) => (
          <Option value={cidade.codCid} key={cidade.codCid}>
            {cidade.nome + ' - ' + cidade.siglaEstado}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default CidadeOrigem;
